module.exports = __webpack_public_path__ + "img/Frame 3183.a09f2a01.png";